import React, { useState, useEffect } from 'react'
import {
    Button,
    Checkbox,
    FormControlLabel,
    InputBase,
    Grid,
    Typography
} from "@material-ui/core";
import useStyles from "./styles";
import { SearchOutlined as SearchIcon } from '@material-ui/icons';
import SearchGrid from '../../components/table/SearchGrid'
import Breadcrums from '../../components/BreadCrums/breadcrums';
import TopSpacer from '../../components/Common/spacer/TopSpacer';

import Submitted from "../../assets/img/action/Submitted.svg";
import ReviewsButtonClicked from "../../assets/img/action/ReviewsButtonClicked.svg";
import EmailOpen from "../../assets/img/action/EmailOpen.svg";

import { PostDataAPI } from '../../Services/APIService';

import Loader from "../../components/Loader/Loader";
import { ActionDialog } from "../../components/ActionDialog/ActionDialog";
import { withSnackbar } from "../../components/Message/Alert";
import SendRequest from './SendRequest/SendRequest';
import ClearIcon from '@material-ui/icons/Clear';
import moment from 'moment';
import { formatDate } from '../../components/Common/Extensions';

function DonationRequest({ ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [editRequestId, setEditRequestId] = useState('')

    const [actiondialogState, setActionDialogState] = useState({
        showHide: false, type: "confirm", message: "",
    })

    const [sendDonationRequest, setSendDonationRequest] = useState(false);

    const openDonationRequest = () => {
        setSendDonationRequest(true)
    }

    const editDonationRequest = (item) => {
        // console.log("this is Item", item);
        setEditRequestId(item.requestId);
        setSendDonationRequest(true)
    }

    const closeDonationRequest = () => {
        setEditRequestId('');
        setSendDonationRequest(false)
    }

    const donationSuccessClose = (message) => {
        setEditRequestId('');
        showMessage("Success", message, "success", 3000);
        setSendDonationRequest(false);
        loadDonationRequest();

    }

    const handleClearInput = (name) => {
        setValue('')
        loadDonationRequest();
    };

    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState(prevState => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback
        }));
    }

    const handleChange = e => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    const [state, setState] = useState({
        confirmed: '', shipped: '', inTransit: '', delivered: '', returned: '',
        claimed: '', voided: '', deleted: ''
    });
    //const [isLoading, setIsLoading] = useState(false);

    const requestStatusBoxes = [
        {
            value: 'New Requests',
            reviewStatus: 'newRequested',
            numbers: '00',
            Icon: Submitted,
        },
        {
            value: 'Emails Opened',
            reviewStatus: 'emailOpened',
            numbers: '00',
            Icon: EmailOpen,
        },
        {
            value: 'Donation Clicked',
            reviewStatus: 'buttonClicked',
            numbers: '00',
            Icon: ReviewsButtonClicked,
        },
       
    ]

    const [ReviewsData, setDonationsData] = useState([]);

    const [searchFilter, setValue] = useState('');
    const handleSearch = (e) => {
        const currValue = e.target.value;

        if (currValue.trim() === "" && currValue !== "") {
            return;
        }

        if (currValue.trim().length > 0 || currValue == '') {
            setValue(currValue);
            handleDataGridUpdate()
        }
    }
    const [isDataGridUpdate, setIsDataGridUpdate] = useState(false);
    const handleDataGridUpdate = () => {
        setIsDataGridUpdate(!isDataGridUpdate);
    }

    const [filteredDonationsData, setFilteredDonationsData] = useState([]);
    const [filteredStatus, setFilteredStatus] = useState([]);

    const handleStatusClick = (event, reviewStatus) => {

        var lstStatus = filteredStatus;
        if (event.target.checked) {
            lstStatus.push(reviewStatus);
        }
        else {
            lstStatus = lstStatus.filter(s => s != reviewStatus)
        }
        setFilteredStatus(lstStatus);
        if (lstStatus.length > 0) {
            setFilteredDonationsData(ReviewsData.filter(o => lstStatus.some(s => s == o.reviewStatus)));
        }
        else {
            setFilteredDonationsData(ReviewsData);
        }

        handleDataGridUpdate();
    }

    const loadDonationRequest = () => {
        setIsLoading(true)
        PostDataAPI("payments/loadDonationRequestGrid").then((result) => {
            setIsLoading(false)
            if (result.success && result.data != null) {
                const record = result.data.map((item, i) => {
                    item.reviewStatus = item.isDonationClicked ? 'buttonClicked' : item.emailOpenedCount > 0 && item.isDonationClicked ? 'emailOpened' : 'newRequested';
                    return {
                        ...item
                    }
                })

                setDonationsData(record);
                setFilteredDonationsData(record);
                //setFilteredData(record.filter(r => r.orderStatus == state.status));

                handleDataGridUpdate();
            }
            else {
                showMessage("Error", result.message, "error", 3000);
            }
            setIsLoading(false);
        })

    }

    const getStatusBg = (filter) => {

        if (filter == 'newRequested') {
            return classes.statusBoxes + " " + "Submitted"
        } else if (filter == 'emailOpened') {
            return classes.statusBoxes + " " + "EmailOpened"
        } else if (filter == 'buttonClicked') {
           return classes.statusBoxes + " " + "donationClicked"
        }
        else if (filter == 'buttonClicked') {
            return classes.statusBoxes + " " + "EmailOpened"
        }
        else {
            return ''
        }
    }
    const getStatusCount = (filter) => {
        if (filter == 'newRequested') {
            return ReviewsData?.filter(t => t.emailOpenedCount == 0).length
        } else if (filter == 'emailOpened') {
            return ReviewsData?.filter(t => t.emailOpenedCount > 0 ).length}
        else if (filter == 'buttonClicked') {
            return ReviewsData?.filter(t => t.isDonationClicked > 0).length
        }
        else {
            return 0
        }
    }
    const expandedRowRender = (item) => {
        return (
            <table className="grid-sub-table">
                <thead>
                    <tr>
                        <td style={{ width: "2%" }}>&nbsp;</td>
                        <td style={{ width: "32%" }}>Donation Partner Information</td>
                        <td style={{ width: "32%" }}>Donation Request Information</td>
                        <td style={{ width: "32%" }}>Log Information</td>
                        <td style={{ width: "2%" }}>&nbsp;</td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td></td>
                        <td>
                            <div className="gridColumnSubItems">
                                <span>
                                    <Typography component="h5">Name: </Typography>
                                    <Typography component="p">{item.firstName + ' ' + item.lastName}</Typography>
                                </span>
                            </div>
                        </td>
                        <td>
                            <div className="gridColumnSubItems">
                                <span>
                                    <Typography component="h5">Date Requested: </Typography>
                                    <Typography component="p">{formatDate(item.createDate)}</Typography></span>
                            </div>                        </td>
                        <td>
                            <div className="gridColumnSubItems">
                                <span>
                                    <Typography component="h5">SMS Sent: </Typography>
                                    <Typography component="p">{item.isSmsSent === true ? 'Yes' : 'No'}</Typography></span>
                            </div>
                        </td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>
                            <div className="gridColumnSubItems">
                                <span>
                                    <Typography component="h5">Email:</Typography>
                                    <Typography component="p">{item.emailAddress}</Typography></span>
                            </div>
                        </td>
                        <td>
                            <div className="gridColumnSubItems">
                                <span>
                                    <Typography component="h5">Amount Requested:</Typography>
                                    <Typography component="p">${item.amount}</Typography></span>
                            </div>
                        </td>
                        <td>
                            <div className="gridColumnSubItems">
                                <span>
                                    <Typography component="h5">Email Sent:</Typography>
                                    <Typography component="p">{item.isEmailSent === true ? 'Yes' : 'No'}</Typography></span>
                            </div>
                        </td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>
                            <div className="gridColumnSubItems">
                                <span>
                                    <Typography component="h5">Phone #:</Typography>
                                    <Typography component="p">{item.phone}</Typography></span>
                            </div>
                        </td>
                        <td>
                            <div className="gridColumnSubItems">
                                <span>
                                    <Typography component="h5">Amount Donated:</Typography>
                                    <Typography component="p">${item.amountDonated !== null ? item.amountDonated : 0}</Typography></span>
                            </div>
                        </td>
                        <td>
                            <div className="gridColumnSubItems">
                                <span>
                                    <Typography component="h5">Email Opened Count:</Typography>
                                    <Typography component="p">{item.emailOpenedCount !== null ? item.emailOpenedCount : 0}</Typography>
                                </span>
                            </div>
                        </td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>
                            <div className="gridColumnSubItems">
                                <span>
                                    <Typography component="h5">Address:</Typography>
                                    <Typography component="p">{item.address + ', ' + item.city + ', ' + item.state + ' ' + item.zipcode}</Typography>
                                </span>
                            </div>
                        </td>
                        <td>&nbsp;</td>
                        <td>
                            <div className="gridColumnSubItems">
                                <span>
                                    <Typography component="h5">Donation Clicked:</Typography>
                                    <Typography component="p">{item.isDonationClicked === true ? 'Yes' : 'No'}</Typography>
                                </span>
                            </div>
                        </td>
                        <td></td>
                    </tr>
                </tbody></table>
        )
    };
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const onTableRowExpand = (expanded, record) => {
        const keys = [];
        if (expanded) {
            keys.push(record.requestId); // I have set my record.id as row key. Check the documentation for more details.
        }

        setExpandedRowKeys(keys);
    }
    useEffect(() => {
        loadDonationRequest();
    }, []);

    return (
        <>
            {isLoading ? <Loader></Loader> : ''}
            <TopSpacer></TopSpacer>

            <div className={classes.header}>

                <Grid container alignItems="baseline">
                    <Grid item lg={12}>
                        <Breadcrums parentLink={"Donation Request"} currentLink={""} isBack={true}></Breadcrums>
                    </Grid>
                </Grid>

            </div>

            <Grid container className={classes.container}>
                <h1 className={classes.heading}>
                    Donation Request
                </h1>
            </Grid>

            <Grid container row className={classes.container}>

                <div className={classes.statusBoxContainer}>

                    {requestStatusBoxes.map((item, i) => (
                        <>
                            <FormControlLabel
                                className={classes.checkBoxFormLabel}
                                control={
                                    <Checkbox
                                        name="checkedB"
                                        color="primary"
                                        className={classes.checkBoxBtn}
                                        onClick={(e) => { handleStatusClick(e, item.reviewStatus) }}
                                    />
                                }

                                label={<>
                                    <div className={getStatusBg(item.reviewStatus)}>

                                        <div className={classes.statusBoxContent}>
                                        <img src={item.Icon} width="70px"/>
                                            <h2>{getStatusCount(item.reviewStatus)}</h2>
                                            <h5>
                                            {item.value}</h5>
                                           
                                            
                                        </div>
                                        

                                    </div>
                                </>}
                            />
                        </>
                    ))}

                </div>

            </Grid>

            <Grid row className={classes.gridHeader}>

                <div className={classes.gridActions}>
                    <Button className={classes.changeBtn} onClick={openDonationRequest}>Ask for donation</Button>
                </div>

                <div className={classes.gridActions} style={{ marginRight: '7px' }} >
                    <InputBase
                        value={searchFilter}
                        placeholder="Search"
                        className="grid-search-input"
                        startAdornment={<SearchIcon />}
                        onChange={handleSearch}
                        endAdornment={searchFilter ? <ClearIcon style={{ cursor: 'pointer' }} onClick={() => { handleClearInput('search') }} /> : ''}
                    />

                </div>
            </Grid>

            <Grid row className={classes.container} >
                <SearchGrid columns="donationRequest"
                    list={filteredDonationsData}
                    noRecordMsg="No donation exists"
                    Icon={true}
                    filter={searchFilter}
                    isUpdate={isDataGridUpdate}
                    onEditClick={(item) => editDonationRequest(item)}
                    expandedRowRender={expandedRowRender}
                    expandedRowKeys={expandedRowKeys}
                    onTableRowExpand={onTableRowExpand}
                />
            </Grid>


            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState(prevState => ({
                        ...prevState, showHide: false
                    }))
                }
                onClose={() => setActionDialogState(prevState => ({
                    ...prevState, showHide: false
                }))

                }
            />

            {sendDonationRequest ?
                <SendRequest
                    dialogOpenClose={openDonationRequest}
                    handleClose={closeDonationRequest}
                    handleSuccessClose={donationSuccessClose}
                    editRecordId={editRequestId}
                ></SendRequest>
                : ''}

        </>
    )

}

export default withSnackbar(DonationRequest);